export default __webpack_public_path__ + "static/pay-it-faster-video@3x-55f88e7705523da999f5690faa954962.png";